
import { Component, Vue, Prop } from "vue-property-decorator";
import { TTask_Table, API_TTask } from "@/models/tasks_services";
import { TO_DO_TASK_STATUS } from "@/constants/tasks";
import { SMUser } from "@/store";
import { EMPLOYER_ROLE } from "@/constants/roles";
import { API_ROUTES } from "@/utils/API";
import WidgetTemplate from "@/components/Widgets/Templates/WidgetTemplate.vue";
import Image from "@/assets/images/people/person-1.png";

const TASKS_PATH = "/cases/tasks/";

@Component({
  components: {
    WidgetTemplate,
  },
})
export default class HelloEmployerWidget extends Vue {
  @Prop({ type: String }) readonly jobTitle?: string;
  @Prop({ type: String }) readonly name?: string;

  get showList() {
    return SMUser.user?.role !== EMPLOYER_ROLE;
  }

  get list() {
    if (SMUser.user?.role === EMPLOYER_ROLE) {
      return this.$t("list.employer", { returnObjects: true });
    }

    return this.$t("list.candidate", { returnObjects: true });
  }

  image = Image;

  get caseId(): number {
    return Number(this.$route.params.id ?? 0);
  }

  tasks = [];

  async getTasks() {
    const { data } = await this.axios.get(API_ROUTES.CASE_TASKS(this.caseId));

    if (!data) return;

    this.tasks = data.filter((item: TTask_Table) => {
      return item.status === TO_DO_TASK_STATUS && item.user.role === SMUser?.user?.role;
    });
  }

  openFirstToDoTask() {
    if (!this.tasks.length) return;

    const task: API_TTask = this.tasks[0];

    const { ID: id } = task;

    this.$router.push(`${TASKS_PATH}${id}`);
  }

  mounted() {
    this.getTasks();
  }

  activated() {
    // NOTE: This approach helps us to refresh "tasks";
    this.getTasks();
  }
}
